import { Container, Dialog, Divider, Grid, IconButton } from '@material-ui/core'
import React, { useContext, useState } from 'react'
import FlexView from 'react-flexview/lib'
import { ACTIONS, PolicyModificationContextStore } from '../../../context/PolicyModificationContext'
import { Action } from '../../../models/Action'
import { BlueGrayBox } from '../../Core/BlueGrayBox'
import { ContinueButton } from '../../Core/Buttons/ContinueButton'
import { ActionPaper } from '../../Core/Frames/ActionPaper'
import { OperatorBlockView } from '../../Operators/OperatorBlockView'
import { ReactComponent as AddSvg } from '../../../assets/add_reverse.svg'
import CloseIcon from '@material-ui/icons/Close'
import { RiderDetailsForm } from './RiderSection/RiderDetailsForm'
import { CustomErrorPopup } from '../../PopUps/CustomErrorPopup'

export const RiderDetailesModification = ({ onContinue, tabIndex }) => {
  let modifyContext = useContext(PolicyModificationContextStore)

  const [popUpErrorState, setPopUpErrorState] = useState({
    title: '',
    body: '',
    showPopUp: false,
    cancelErrorPopup: undefined,
  })

  const defaultOperator = {
    is_owner: false,
    license_endorsed_for_motorcycle: false,
    education_course: false,
    own_home: false,
    recent_accident: false,
    active_military: false
  }
  const [operatorEditState, setOperatorState] = useState({ operator: defaultOperator, open: false, index: '' })

  const saveRiderDetails = (data, index) => {
    if (index == undefined) {
      const riders = [...modifyContext.rider_details]
      data.id = modifyContext.riderMaxId + 1
      data.is_new = true
      riders.push(data)
      modifyContext.dispatch(new Action(ACTIONS.EDIT_RIDERS, riders))
      modifyContext.dispatch(new Action(ACTIONS.SET_RIDER_MAX_ID, data.id))
    } else {
      const riders = [...modifyContext.rider_details]
      riders[index] = data
      modifyContext.dispatch(new Action(ACTIONS.EDIT_RIDERS, riders))
    }

    if (data.isMvrViolations) {
      setPopUpErrorState({
        title: 'Violation Discrepancy Alert',
        body: 'Policyholder provided inaccurate violation information. Additional/different violations detected and considered.',
        showPopUp: true,
        cancelErrorPopup: () => {
          setPopUpErrorState({ open: false, title: '', body: '', cancelErrorPopup: undefined })
          setOperatorState({ open: false, operator: defaultOperator })
        },
      })
    } else {
      setOperatorState({ open: false, operator: defaultOperator })
    }
  }

  const saveAndContinue = () => {
    let numOfOwners = 0
    modifyContext.rider_details.forEach(rider => {
      if (rider.is_owner) {
        numOfOwners++
      }
    })

    if (numOfOwners == 0) {
      setPopUpErrorState({
        title: 'Hold On..',
        body: "Please mark who's the policy owner",
        showPopUp: true,
      })
    } else if (numOfOwners > 1) {
      setPopUpErrorState({
        title: 'Hold On..',
        body: 'More than one operator is marked as the owner',
        showPopUp: true,
      })
    } else {
      const riderSetToOwner = modifyContext.rider_details.find(r => r.is_owner)
      const policyOwner = {
        ...modifyContext.owner_details,
        first_name: riderSetToOwner.first_name,
        last_name: riderSetToOwner.last_name,
        date_of_birth: riderSetToOwner.date_of_birth,
      }

      modifyContext.dispatch(new Action(ACTIONS.SAVE_RIDERS_DETAILS, policyOwner))
      onContinue(tabIndex)
    }
  }

  const onDeleteOperator = index => {
    const riders = [...modifyContext.rider_details]
    riders.splice(index, 1)
    modifyContext.dispatch(new Action(ACTIONS.REMOVE_RIDER_FROM_POLICY, riders))
  }
  const cancelErrorPopup = () => setPopUpErrorState({ open: false, title: '', body: '', cancelErrorPopup: undefined })

  return (
    <React.Fragment>
      <Container className="margin-top-medium">
        {modifyContext.rider_details.map((operator, index) => (
          <div key={index} className="capitalize">
            <ActionPaper
              deletable
              onDelete={() => onDeleteOperator(index)}
              onView={() => setOperatorState({ open: true, operator: operator, index })}
            >
              <OperatorBlockView firstName={operator.first_name} lastName={operator.last_name} />
            </ActionPaper>
            <br />
          </div>
        ))}

        <BlueGrayBox className="fit-content" onClick={() => setOperatorState({ open: true, operator: defaultOperator })}>
          <FlexView vAlignContent={'center'} className="clickable fit-content">
            <AddSvg />
            <div className="text-body blue margin-left-6">Add additional driver</div>
          </FlexView>
        </BlueGrayBox>
        <Grid xs={4}>
          <FlexView vAlignContent="center" hAlignContent="left" className="margin-top-large">
            <ContinueButton label="Continue" onClick={saveAndContinue} />
          </FlexView>
        </Grid>
      </Container>

      <Dialog fullScreen fullWidth open={operatorEditState.open}>
        <Container>
          <FlexView className="full-width" hAlignContent={'right'}>
            <IconButton onClick={() => setOperatorState({ operator: {}, open: false, special: false })}>
              <CloseIcon />
            </IconButton>
          </FlexView>
          <br />
          <RiderDetailsForm defaultValues={operatorEditState.operator} index={operatorEditState.index} onSave={saveRiderDetails} />
        </Container>
      </Dialog>

      <CustomErrorPopup
        title={popUpErrorState.title}
        body={popUpErrorState.body}
        open={popUpErrorState.showPopUp}
        onCancel={popUpErrorState.cancelErrorPopup === undefined ? cancelErrorPopup : popUpErrorState.cancelErrorPopup}
      />
    </React.Fragment>
  )
}
